import type { BBox, Entry } from "shared";
import { boundsFromEntries, isDegenerateBbox } from "shared";
import type { ViewportTarget } from "./DrawToolbar";

export function viewportForEntries(
	entriesByLayer: Record<string, Entry[]>,
): ViewportTarget | null {
	const entries = Object.values(entriesByLayer).flat();
	if (entries.length === 0) return null;
	const bbox = boundsFromEntries(entries);
	if (!bbox) return null;
	const [minLng, minLat, maxLng, maxLat] = bbox;
	const center: [number, number] = [(minLng + maxLng) / 2, (minLat + maxLat) / 2];
	if (isDegenerateBbox(bbox)) {
		return { center, zoom: 15, bbox: null };
	}
	return { center, bbox: bbox as BBox };
}
